import DashboardPage from "./pages/dashboard-page/dashboard-page";
import GroupsPage from "./pages/groups-page/groups-page";
import OrganizationsPage from "./pages/organizations-page/organizations-page";
import ProfilePage from "./pages/profile-page/profile-page";
import SettingsPage from "./pages/settings-page/settings-page";
import UserProfilePage from "./pages/user-profile-page/user-profile-page";
import UsersPage from "./pages/users-page/users-page";
import DeepLinksPage from "./pages/deeplinks-page/deeplinks-page";
import LeadLinksPage from "./pages/lead-links-page/lead-links-page";
import { ReactComponent as SuperAdminIcon } from "./assets/icons/symmio-icons/icon_super-admin.svg";
import { ReactComponent as OrgMgmtIcon } from "./assets/icons/symmio-icons/icon_org-mgmt.svg";
import { ReactComponent as OrgIcon } from "./assets/icons/nav/icon_org-structure.svg";
import { ReactComponent as ReportingIcon } from "./assets/icons/nav/icon_reporting.svg";
import { ReactComponent as SettingsIcon } from "./assets/icons/nav/icon_settings.svg";
import { ReactComponent as ResourcesIcon } from "./assets/icons/nav/icon_resources.svg";
import { ReactComponent as UsersIcon } from "./assets/icons/nav/icon_users.svg";
import { ReactComponent as DashboardIcon } from "./assets/icons/nav/icon_dashboard.svg";
import { ReactComponent as LinksIcon } from "./assets/icons/nav/icon_links.svg";
// import { ReactComponent as DataExportIcon } from "./assets/icons/nav/icon_data-export.svg";
import GroupEditPage from "./pages/groups-page/group-edit-page";
import LinkAddEditPage from "./pages/links/link-add-edit";
import UserRoles from "./models/user-roles";
import { AddOrganizationPage } from "./pages/organizations-page/add-organization-page";
// import ExportPage from "./pages/data-export-page/data-export-page";
import Lifestyle from "./pages/lifestyle/lifestyle";
import Movement from "./pages/movement/movement";
import AccountSetup from "./pages/account-setup/account-setup";
import ExportPage from "./pages/data-export-page/data-export-page";
import ChangePlan from "./components/subscription/change-plan";
import EnterpriseContactUs from "./components/subscription/enterprise-contact-us";
import LeadLinkAddEditPage from "./pages/lead-capture/lead-link-add-edit-page";
import SubscriptionLinksPage from "./pages/subscription-link/subscription-links-page";
import SubscriptionLinkAddEditPage from "./pages/subscription-link/subscription-link-add-edit-page";
import ResourcesPage from "./pages/resources/resources-page";
import i18n from "./i18n";
import TrialDeactivated from "./pages/trial-deactivated/trial-deactivated";
import PlanDeactivated from "./pages/plan-deactivated/plan-deactivated";
import SuperAdminToolsPage from "./pages/super-admin-tools/super-admin-tools-page";
import ReportDetailDynamic from "./components/report/report-detail-dynamic";
import ReportScoreDynamic from "./components/report/report-score-dynamic";
import ReportMovementDynamic from "./components/report/report-movement-dynamic";
import ReportComplianceDynamic from "./components/report/report-compliance-dynamic";
import ReportWellnessSummaryDynamic from "./components/report/report-wellness-summary-dynamic";
import ReportSummaryDynamic from "./components/report/report-summary-dynamic";
import MskLitePage from "./pages/msk-lite/msk-lite-page";

export const siteMap = [
    {
        name: "Trial Deactivated",
        translationName: i18n.t('sitemap.trialDeactivated'),
        path: "/trial-deactivated",
        component: TrialDeactivated,
        includeInNav: false,
    },
    {
        name: "Plan Deactivated",
        translationName: i18n.t('sitemap.planDeactivated'),
        path: "/plan-deactivated",
        component: PlanDeactivated,
        includeInNav: false,
    },
    {
        name: "Super Admin",
        translationName: i18n.t('sitemap.superAdmin'),
        path: "/organizations",
        component: OrganizationsPage,
        includeInNav: true,
        includeInUserNav: false,
        icon: SuperAdminIcon,
        navOrder: 10,
        onlySuperadmin: true,
    },
    {
        name: "Org Mgmt",
        translationName: i18n.t('sitemap.orgMgmt'),
        path: "/organizations",
        component: OrganizationsPage,
        includeInNav: true,
        includeInUserNav: false,
        icon: OrgMgmtIcon,
        navOrder: 10,
        requiredRoles: [UserRoles.ACCOUNT_HOLDER_ID],
        onlySuperadmin: false,
    },
    {
        name: "Add Organization",
        translationName: i18n.t('sitemap.addOrg'),
        path: "/organization",
        component: AddOrganizationPage,
        includeInNav: false,
        includeInUserNav: false,
        requiredRoles: [UserRoles.ACCOUNT_HOLDER_ID],
    },
    {
        name: "Structure",
        translationName: i18n.t('sitemap.structure'),
        path: "/groups",
        component: GroupsPage,
        includeInNav: true,
        includeInUserNav: false,
        icon: OrgIcon,
        requiredRoles: [UserRoles.ADMIN_ID, UserRoles.GROUP_MANAGER_ID, UserRoles.ACCOUNT_HOLDER_ID],
        navOrder: 30,
    },
    {
        name: "Edit Group",
        translationName: i18n.t('sitemap.editGroup'),
        path: "/group/:organizationId/:id",
        component: GroupEditPage,
        includeInNav: false,
        includeInUserNav: false,
        requiredRoles: [UserRoles.ADMIN_ID, UserRoles.GROUP_MANAGER_ID, UserRoles.ACCOUNT_HOLDER_ID],
    },
    {
        name: "Add Group",
        translationName: i18n.t('sitemap.addGroup'),
        path: "/group/:organizationId",
        component: GroupEditPage,
        includeInNav: false,
        includeInUserNav: false,
        requiredRoles: [UserRoles.ADMIN_ID, UserRoles.GROUP_MANAGER_ID, UserRoles.ACCOUNT_HOLDER_ID],
    },
    {
        name: "Upgrade Organization",
        translationName: i18n.t('sitemap.upgradeOrg'),
        path: "/settings/change-plan/contact-us",
        component: EnterpriseContactUs,
        includeInNav: false,
        includeInUserNav: false,
        requiredRoles: [UserRoles.ADMIN_ID, UserRoles.ACCOUNT_HOLDER_ID],
    },
    {
        name: "Upgrade Organization",
        translationName: i18n.t('sitemap.upgradeOrg'),
        path: "/settings/upgrade",
        component: ChangePlan,
        includeInNav: false,
        includeInUserNav: false,
        requiredRoles: [UserRoles.ADMIN_ID, UserRoles.ACCOUNT_HOLDER_ID],
    },
    {
        name: "User Profile",
        translationName: i18n.t('sitemap.userProfile'),
        path: "/users/:id",
        component: UserProfilePage,
        includeInNav: false,
        includeInUserNav: false,
    },
    {
        name: "Users",
        translationName: i18n.t('sitemap.users'),
        path: "/users",
        component: UsersPage,
        includeInNav: true,
        includeInUserNav: false,
        icon: UsersIcon,
        requiredRoles: [UserRoles.ADMIN_ID, UserRoles.GROUP_MANAGER_ID, UserRoles.ACCOUNT_HOLDER_ID],
        navOrder: 40,
    },
    {
        name: "Report",
        translationName: i18n.t('sitemap.reports'),
        path: "/reports/detail",
        component: ReportDetailDynamic,
        includeInNav: true,
        includeInUserNav: false,
        icon: ReportingIcon,
        navOrder: 50,
    },
    {
        name: "Score Report",
        translationName: i18n.t('sitemap.reports'),
        path: "/reports/score",
        component: ReportScoreDynamic,
        includeInNav: false,
        includeInUserNav: false,
        icon: ReportingIcon,
        navOrder: 50,
    },
    {
        name: "Movement Report",
        translationName: i18n.t('sitemap.reports'),
        path: "/reports/movement",
        component: ReportMovementDynamic,
        includeInNav: false,
        includeInUserNav: false,
        icon: ReportingIcon,
        navOrder: 50,
    },
    {
        name: "Compliance Report",
        translationName: i18n.t('sitemap.reports'),
        path: "/reports/compliance",
        component: ReportComplianceDynamic,
        includeInNav: false,
        includeInUserNav: false,
        icon: ReportingIcon,
        navOrder: 50,
    },
    {
        name: "Wellness Summary Report",
        translationName: i18n.t('sitemap.reports'),
        path: "/reports/wellness-summary",
        component: ReportWellnessSummaryDynamic,
        includeInNav: false,
        includeInUserNav: false,
        icon: ReportingIcon,
        navOrder: 50,
    },
    {
        name: "Summary Report",
        translationName: i18n.t('sitemap.reports'),
        path: "/reports/summary",
        component: ReportSummaryDynamic,
        includeInNav: false,
        includeInUserNav: false,
        icon: ReportingIcon,
        navOrder: 50,
    },
    {
        name: "Links",
        translationName: i18n.t('sitemap.links'),
        path: "/invitelinks",
        component: DeepLinksPage,
        includeInNav: true,
        includeInUserNav: false,
        icon: LinksIcon,
        requiredRoles: [UserRoles.ADMIN_ID, UserRoles.ACCOUNT_HOLDER_ID, UserRoles.GROUP_MANAGER_ID],
        navOrder: 60,
    },
    {
        name: "Lead Capture",
        translationName: i18n.t('sitemap.leadCapture'),
        path: "/lead-capture",
        component: LeadLinksPage,
        includeInNav: false,
        includeInUserNav: false,
        navOrder: 60,
        onlySuperadmin: true,
    },
    {
        name: "Super Admin Tools",
        translationName: i18n.t('sitemap.superAdminTools'),
        path: "/super-admin-tools",
        component: SuperAdminToolsPage,
        includeInNav: false,
        includeInUserNav: false,
        navOrder: 60,
        onlySuperadmin: true,
    },
    {
        name: "MSK Lite",
        translationName: i18n.t('sitemap.mskLite'),
        path: "/msk-lite",
        component: MskLitePage,
        includeInNav: false,
        includeInUserNav: false,
        onlySuperadmin: true,
    },
    {
        name: "Subscription Links",
        translationName: i18n.t('sitemap.subLinks'),
        path: "/subscription-links",
        component: SubscriptionLinksPage,
        includeInNav: false,
        includeInUserNav: false,
        navOrder: 60,
        onlySuperadmin: true,
    },
    {
        name: "Settings",
        translationName: i18n.t('sitemap.settings'),
        path: "/settings",
        component: SettingsPage,
        includeInNav: true,
        includeInUserNav: false,
        icon: SettingsIcon,
        navOrder: 70,
    },
    {
        name: "Export",
        translationName: i18n.t('sitemap.export'),
        path: "/data-export",
        component: ExportPage,
        includeInNav: false,
        includeInUserNav: false,
        navOrder: 80,
        onlySuperadmin: true,
    },
    {
        name: "Resources",
        translationName: i18n.t('sitemap.resources'),
        path: "/resources",
        component: ResourcesPage,
        includeInNav: true,
        includeInUserNav: false,
        icon: ResourcesIcon,
        navOrder: 90,
        onlySuperadmin: false,
    },
    {
        name: "Profile",
        translationName: i18n.t('sitemap.profile'),
        path: "/profile",
        component: ProfilePage,
        includeInNav: false,
        includeInUserNav: false,
    },
    {
        name: "Lifestyle",
        translationName: i18n.t('sitemap.lifestyle'),
        path: "/lifestyle",
        component: Lifestyle,
        includeInNav: false,
    },
    {
        name: "Movement",
        translationName: i18n.t('sitemap.movement'),
        path: "/movement",
        component: Movement,
        includeInNav: false,
    },
    {
        name: "Account Setup",
        translationName: i18n.t('sitemap.setup'),
        path: "/setup",
        component: AccountSetup,
        includeInNav: false,
    },
    {
        name: "Edit Deep Link",
        translationName: i18n.t('sitemap.editDeepLink'),
        path: "/invitelink/:id",
        component: LinkAddEditPage,
    },
    {
        name: "Add Deep Link",
        translationName: i18n.t('sitemap.addDeepLink'),
        path: "/invitelink/",
        component: LinkAddEditPage,
    },
    {
        name: "Edit Lead Capture Link",
        translationName: i18n.t('sitemap.editLeadCapture'),
        path: "/lead-capture-link/:id",
        component: LeadLinkAddEditPage,
        onlySuperadmin: true,
    },
    {
        name: "Add Lead Capture Link",
        translationName: i18n.t('sitemap.addLeadCapture'),
        path: "/lead-capture-link",
        component: LeadLinkAddEditPage,
        onlySuperadmin: true,
    },
    {
        name: "Edit Subscription Link",
        translationName: i18n.t('sitemap.editSubLink'),
        path: "/subscription-link/:id",
        component: SubscriptionLinkAddEditPage,
        onlySuperadmin: true,
    },
    {
        name: "Add Subscription Link",
        translationName: i18n.t('sitemap.addSubLink'),
        path: "/subscription-link",
        component: SubscriptionLinkAddEditPage,
        onlySuperadmin: true,
    },
    {
        name: "Dashboard",
        translationName: i18n.t('sitemap.dashboard'),
        path: "/dashboard",
        component: DashboardPage,
        includeInNav: true,
        includeInUserNav: false,
        icon: DashboardIcon,
        navOrder: 20,
    },
    // This part is only for setting up the default home page in the router
    {
        name: "",
        path: "/",
        component: DashboardPage,
        includeInNav: false,
        includeInUserNav: false,
        icon: null,
        navOrder: 0,
    },
];
